import React from 'react';
export const useIsFinishedInstalling = () => {
  const [isInstallingFinished, setIsInstallingFinished] = React.useState(false);
  return [isInstallingFinished, setIsInstallingFinished];
};
//# sourceMappingURL=useIsInstallingFinished.js.map